import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  FormGroup,
  Input,
  Form,
  Button,
} from "reactstrap";
import "moment-timezone";
import { useState, React, useEffect, useContext } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;
import { ToastContainer, toast } from "react-toastify";
import Switch from "react-bootstrap-switch";
import { MainContext } from "context/MainContext.js";
import { type as provisiningTypes } from "data/provisioning";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";
import SelectComponent from "components/Utils/select";

const GamConfigurationEdit = () => {
  const history = useHistory();
  const location = useLocation();

  const [showLoading, setShowLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [errorMsg, setErrorMsg] = useState([]);

  const [typeList, setTypeList] = useState(provisiningTypes);
  const [selectedType, setSelectedType] = useState("general");

  let formError = false;

  const [params, setParams] = useState(location.state?.value ?? "");

  const [mode, setMode] = useState(location.state ? location.state.mode : "");
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (
      !Utilities.hasAccess(privileges["automations.gam.configuration.edit"])
    ) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }

    if (mode == "edit") {
      fetch("/api/v1/automation/gam/configuration/edit", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          sessionId: sessionStorage.getItem("sessionId"),
          serialNumber: params.split("||")[1],
        },
      })
        .then((response) => response.json())
        .then((actualData) => {
          setShowLoading(false);
          if (actualData.status == "200") {
            setValues(actualData.data.provisioning);
            setDefaultType(actualData.data.provisioning.type);
          }
        })
        .catch((err) => {
          console.log(err.message);
          setShowLoading(false);
        });
    } else if (mode == "create") {
      fetch("/api/v1/automation/gam/configuration/create", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          sessionId: sessionStorage.getItem("sessionId"),
        },
      })
        .then((response) => response.json())
        .then((actualData) => {
          setShowLoading(false);
        })
        .catch((err) => {
          console.log(err.message);
          setShowLoading(false);
        });
    }
  }, []);

  const [values, setValues] = useState({
    // System Info
    serialNumber: "",
    type: "",
    allowManualChange: false,

    // Basic Information
    syncBasicInformation: false,
    systemName: "",
    systemContact: "",
    systemLocation: "",

    // IPv4 Information
    syncIpv4Information: false,
    managementVlan: 4093,
    ipv4Address: "",
    ipv4Netmask: "",
    ipv4DefaultGateway: "",

    // DNS Information
    syncDnsInformation: false,
    ipv4DNSName0: "",
    ipv4DNSName1: "",
    ipv4DNSName2: "",
    ipv4DNSName3: "",

    // IPTV
    syncIptvInformation: false,
    iptvEnabled: false,
    iptvVlan: "",

    // Banner
    syncBannerInformation: false,
    bannerLogin: "",
  });

  const [states, setStates] = useState({
    // System Info
    serialNumber: "",
    type: "",
    allowManualChange: "",

    // Basic Information
    syncBasicInformation: "",
    systemName: "",
    systemContact: "",
    systemLocation: "",

    // IPv4 Information
    syncIpv4Information: "",
    managementVlan: "",
    ipv4Address: "",
    ipv4Netmask: "",
    ipv4DefaultGateway: "",

    // DNS Information
    syncDnsInformation: "",
    ipv4DNSName0: "",
    ipv4DNSName1: "",
    ipv4DNSName2: "",
    ipv4DNSName3: "",

    // IPTV
    syncIptvInformation: "",
    iptvEnabled: "",
    iptvVlan: "",

    // Banner
    syncBannerInformation: "",
    bannerLogin: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSwitchChange = (e) => {
    const { props, state } = e;

    setValues({
      ...values,
      [props.name]: state.value,
    });
  };

  const handleTypeChange = (option) => {
    setValues({
      ...values,
      ["type"]: option.value.value,
    });
    setSelectedType(option);
  };

  const setDefaultType = (defaultValue) => {
    typeList.forEach((item) => {
      if (item.value == defaultValue) {
        setSelectedType(item);
        setValues((prevState) => ({
          ...prevState,
          ["type"]: defaultValue,
        }));
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    formError = false;

    setStates({
      ...states,
      serialNumber: validateField("serialNumber"),
      // IPv4
      ipv4Address: validateIpAddress("ipv4Address"),
      ipv4Netmask: validateIpAddress("ipv4Netmask"),
      ipv4DefaultGateway: validateIpAddress("ipv4DefaultGateway"),
      // DNS
      ipv4DNSName0: validateDnsName("ipv4DNSName0"),
      ipv4DNSName1: validateDnsName("ipv4DNSName1"),
      ipv4DNSName2: validateDnsName("ipv4DNSName2"),
      ipv4DNSName3: validateDnsName("ipv4DNSName3"),
    });

    if (!formError) {
      postData();
    }
  };

  const validateField = (field) => {
    let status = "";

    if (values[field] === "") {
      status = "This field is required";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }
    return status;
  };

  const postData = () => {
    setShowLoading(true);

    let apiUrl = "";
    let apiMethod = "";

    if (mode == "edit") {
      apiUrl = "/api/v1/automation/gam/configuration/edit";
      apiMethod = "PUT";
    } else if (mode == "create") {
      apiUrl = "/api/v1/automation/gam/configuration/create";
      apiMethod = "POST";
    }

    fetch(apiUrl, {
      method: apiMethod,
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        // System Information
        serialNumber: values.serialNumber,
        type: values.type,
        allowManualChange: values.allowManualChange,

        // Basic Information
        syncBasicInformation: values.syncBasicInformation,
        systemName: values.systemName,
        systemContact: values.systemContact,
        systemLocation: values.systemLocation,

        // IPv4 Information
        syncIpv4Information: values.syncIpv4Information,
        managementVlan: values.managementVlan,
        ipv4Address: values.ipv4Address,
        ipv4Netmask: values.ipv4Netmask,
        ipv4DefaultGateway: values.ipv4DefaultGateway,

        // DNS Management
        syncDnsInformation: values.syncDnsInformation,
        ipv4DNSName0: values.ipv4DNSName0,
        ipv4DNSName1: values.ipv4DNSName1,
        ipv4DNSName2: values.ipv4DNSName2,
        ipv4DNSName3: values.ipv4DNSName3,

        // IPTV Management
        syncIptvInformation: values.syncIptvInformation,
        iptvVlan: values.iptvVlan,
        iptvEnabled: values.iptvEnabled,

        // Banner Information
        syncBannerInformation: values.syncBannerInformation,
        bannerLogin: values.bannerLogin,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while saving the GAM configuration", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);
          toast.success("GAM configuration saved successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });

          redirectToListPage();
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const redirectToListPage = () => {
    const location = {
      pathname: "/admin/automations/configuration/list",
    };
    history.push(location);
  };

  const validateIpAddress = (field) => {
    let status = "";
    const ipRegex =
      /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

    if (values[field] && !ipRegex.test(values[field])) {
      status = "Invalid IP address format (e.g. 192.168.1.1)";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }
    return status;
  };

  const validateDnsName = (field) => {
    let status = "";
    const ipRegex =
      /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
    const hostnameRegex =
      /^[a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?)*$/;

    if (
      values[field] !== "" &&
      !ipRegex.test(values[field]) &&
      !hostnameRegex.test(values[field])
    ) {
      status = "Invalid IP address or hostname format";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }
    return status;
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        {alert}
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        {errorMsg.length > 0 ? (
          <div
            style={{
              backgroundColor: "#FFC0A4",
              border: "1px solid #ef8157",
              color: "#66615b",
              paddingTop: "15px",
              marginBottom: "15px",
            }}
          >
            <ul>
              {errorMsg.map((d, index) => (
                <li key={index}>{d}</li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        )}
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md="12">
              {/* Breadcrumb */}
              <Card>
                <CardBody>
                  <Breadcrumb>
                    <BreadcrumbItem>
                      <NavLink
                        to={{
                          pathname: "/admin/dashboard",
                        }}
                      >
                        <FontAwesomeIcon icon={faHome} />
                      </NavLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem>Automations</BreadcrumbItem>
                    <BreadcrumbItem>
                      <NavLink
                        to={{
                          pathname: "/admin/automations/configuration/list",
                        }}
                      >
                        GAM Configuration
                        {params.includes("serialNumber") ? (
                          <i>&lt;{params.split("||")[1]}&gt;</i>
                        ) : (
                          ""
                        )}
                      </NavLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem>
                      {mode == "create" ? "Create" : ""}
                      {mode == "edit" ? "Edit" : ""}
                    </BreadcrumbItem>
                  </Breadcrumb>
                </CardBody>
              </Card>

              {/* System Information */}
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <h5 className="card-title">System Information</h5>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  {" "}
                  <Row>
                    <Col>
                      <label className={"settingLabel"}>Serial Number</label>
                      <FormGroup
                        className={
                          states["serialNumber"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Input
                          type="text"
                          name="serialNumber"
                          onChange={handleInputChange}
                          value={values.serialNumber}
                          readOnly={mode == "edit" ? true : false}
                        />
                        <label className="error">
                          {states["serialNumber"]}
                        </label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <label className={"settingLabel"}>Type</label>
                      <SelectComponent
                        fieldName={"type"}
                        array={typeList}
                        stateValue={states["type"]}
                        onChange={(option) => {
                          handleTypeChange(option);
                        }}
                        selectedOption={selectedType}
                      />
                    </Col>
                    <Col>
                      <label className={"settingLabel"}>
                        Allow Manual Change
                      </label>
                      <FormGroup>
                        <Switch
                          name="allowManualChange"
                          offColor="success"
                          offText={<i className="nc-icon nc-simple-remove" />}
                          onColor="success"
                          onText={<i className="nc-icon nc-check-2" />}
                          onChange={handleSwitchChange}
                          value={values["allowManualChange"] ? true : false}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {/* Basic Information and IPV4 Management */}
              <Row>
                <Col>
                  <Card>
                    <CardHeader>
                      <Row className="align-items-center">
                        <Col>
                          <div className="d-flex align-items-center">
                            <h5 className="card-title mb-0 me-3">
                              Basic Information
                            </h5>
                            <div className="d-flex align-items-center">
                              <Switch
                                name="syncBasicInformation"
                                offColor="success"
                                offText={
                                  <i className="nc-icon nc-simple-remove" />
                                }
                                onColor="success"
                                onText={<i className="nc-icon nc-check-2" />}
                                onChange={handleSwitchChange}
                                value={
                                  values["syncBasicInformation"] ? true : false
                                }
                                className="align-self-center"
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <label className={"settingLabel"}>System Name</label>
                          <FormGroup
                            className={
                              states["systemName"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="systemName"
                              onChange={handleInputChange}
                              value={values.systemName}
                              readOnly={!values.syncBasicInformation}
                            />
                            <label className="error">
                              {states["systemName"]}
                            </label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>
                            System Contact
                          </label>
                          <FormGroup
                            className={
                              states["systemContact"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="systemContact"
                              onChange={handleInputChange}
                              value={values.systemContact}
                              readOnly={
                                !values.syncBasicInformation ||
                                values.type == "hospitality"
                              }
                            />
                            <label className="error">
                              {states["systemContact"]}
                            </label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>
                            System Location
                          </label>
                          <FormGroup
                            className={
                              states["systemLocation"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="systemLocation"
                              onChange={handleInputChange}
                              value={values.systemLocation}
                              readOnly={!values.syncBasicInformation}
                            />
                            <label className="error">
                              {states["systemLocation"]}
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col>
                  <Card>
                    <CardHeader>
                      <Row className="align-items-center">
                        <Col>
                          <div className="d-flex align-items-center">
                            <h5 className="card-title mb-0 me-3">
                              IPv4 Management
                            </h5>
                            <div className="d-flex align-items-center">
                              <Switch
                                name="syncIpv4Information"
                                offColor="success"
                                offText={
                                  <i className="nc-icon nc-simple-remove" />
                                }
                                onColor="success"
                                onText={<i className="nc-icon nc-check-2" />}
                                onChange={handleSwitchChange}
                                value={
                                  values["syncIpv4Information"] ? true : false
                                }
                                className="align-self-center"
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <label className={"settingLabel"}>
                            Management VLAN
                          </label>
                          <FormGroup
                            className={
                              states["managementVlan"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="managementVlan"
                              value={values.managementVlan}
                              onChange={handleInputChange}
                              readOnly={
                                !values.syncIpv4Information ||
                                values.type == "hospitality"
                              }
                            />
                            <label className="error">
                              {states["managementVlan"]}
                            </label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>IPv4 Address</label>
                          <FormGroup
                            className={
                              states["ipv4Address"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="ipv4Address"
                              value={values.ipv4Address}
                              onChange={handleInputChange}
                              readOnly={!values.syncIpv4Information}
                            />
                            <label className="error">
                              {states["ipv4Address"]}
                            </label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>IPv4 Netmask</label>
                          <FormGroup
                            className={
                              states["ipv4Netmask"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="ipv4Netmask"
                              value={values.ipv4Netmask}
                              onChange={handleInputChange}
                              readOnly={
                                !values.syncIpv4Information ||
                                values.type == "hospitality"
                              }
                            />
                            <label className="error">
                              {states["ipv4Netmask"]}
                            </label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>
                            Default Gateway
                          </label>
                          <FormGroup
                            className={
                              states["ipv4DefaultGateway"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="ipv4DefaultGateway"
                              onChange={handleInputChange}
                              value={values.ipv4DefaultGateway}
                              readOnly={
                                !values.syncIpv4Information ||
                                values.type == "hospitality"
                              }
                            />
                            <label className="error">
                              {states["ipv4DefaultGateway"]}
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              {/* IPTV Information and DNS Management*/}
              <Row>
                <Col>
                  <Card>
                    <CardHeader>
                      <Row className="align-items-center">
                        <Col>
                          <div className="d-flex align-items-center">
                            <h5 className="card-title mb-0 me-3">
                              IPTV Information
                            </h5>
                            <div className="d-flex align-items-center">
                              <Switch
                                name="syncIptvInformation"
                                offColor="success"
                                offText={
                                  <i className="nc-icon nc-simple-remove" />
                                }
                                onColor="success"
                                onText={<i className="nc-icon nc-check-2" />}
                                onChange={handleSwitchChange}
                                value={
                                  values["syncIptvInformation"] ? true : false
                                }
                                className="align-self-center"
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <label className={"settingLabel"}>VLAN</label>
                          <FormGroup
                            className={
                              states["iptvVlan"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="iptvVlan"
                              value={values.iptvVlan}
                              onChange={handleInputChange}
                              readOnly={
                                !values.syncIptvInformation ||
                                values.type == "hospitality"
                              }
                            />
                            <label className="error">
                              {states["iptvVlan"]}
                            </label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>Enabled</label>
                          <FormGroup>
                            <Switch
                              name="iptvEnabled"
                              offColor="success"
                              offText={
                                <i className="nc-icon nc-simple-remove" />
                              }
                              onColor="success"
                              onText={<i className="nc-icon nc-check-2" />}
                              onChange={handleSwitchChange}
                              value={values["iptvEnabled"] ? true : false}
                              disabled={
                                !values.syncIptvInformation ||
                                values.type == "hospitality"
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col></Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col>
                  <Card>
                    <CardHeader>
                      <Row className="align-items-center">
                        <Col>
                          <div className="d-flex align-items-center">
                            <h5 className="card-title mb-0 me-3">
                              DNS Management
                            </h5>
                            <div className="d-flex align-items-center">
                              <Switch
                                name="syncDnsInformation"
                                offColor="success"
                                offText={
                                  <i className="nc-icon nc-simple-remove" />
                                }
                                onColor="success"
                                onText={<i className="nc-icon nc-check-2" />}
                                onChange={handleSwitchChange}
                                value={
                                  values["syncDnsInformation"] ? true : false
                                }
                                className="align-self-center"
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <label className={"settingLabel"}>
                            IPv4 DNS Name 0
                          </label>
                          <FormGroup
                            className={
                              states["ipv4DNSName0"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="ipv4DNSName0"
                              value={values.ipv4DNSName0}
                              onChange={handleInputChange}
                              readOnly={
                                !values.syncDnsInformation ||
                                values.type == "hospitality"
                              }
                            />
                            <label className="error">
                              {states["ipv4DNSName0"]}
                            </label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>
                            IPv4 DNS Name 1
                          </label>
                          <FormGroup
                            className={
                              states["ipv4DNSName1"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="ipv4DNSName1"
                              value={values.ipv4DNSName1}
                              onChange={handleInputChange}
                              readOnly={
                                !values.syncDnsInformation ||
                                values.type == "hospitality"
                              }
                            />
                            <label className="error">
                              {states["ipv4DNSName1"]}
                            </label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>
                            IPv4 DNS Name 2
                          </label>
                          <FormGroup
                            className={
                              states["ipv4DNSName2"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="ipv4DNSName2"
                              value={values.ipv4DNSName2}
                              onChange={handleInputChange}
                              readOnly={
                                !values.syncDnsInformation ||
                                values.type == "hospitality"
                              }
                            />
                            <label className="error">
                              {states["ipv4DNSName2"]}
                            </label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>
                            IPv4 DNS Name 3
                          </label>
                          <FormGroup
                            className={
                              states["ipv4DNSName3"].length !== 0
                                ? "has-danger"
                                : ""
                            }
                          >
                            <Input
                              type="text"
                              name="ipv4DNSName3"
                              value={values.ipv4DNSName3}
                              onChange={handleInputChange}
                              readOnly={
                                !values.syncDnsInformation ||
                                values.type == "hospitality"
                              }
                            />
                            <label className="error">
                              {states["ipv4DNSName3"]}
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              {/* Banner */}
              <Row>
                <Col>
                  <Card>
                    <CardHeader>
                      <Row className="align-items-center">
                        <Col>
                          <div className="d-flex align-items-center">
                            <h5 className="card-title mb-0 me-3">
                              Banner Information
                            </h5>
                            <div className="d-flex align-items-center">
                              <Switch
                                name="syncBannerInformation"
                                offColor="success"
                                offText={
                                  <i className="nc-icon nc-simple-remove" />
                                }
                                onColor="success"
                                onText={<i className="nc-icon nc-check-2" />}
                                onChange={handleSwitchChange}
                                value={
                                  values["syncBannerInformation"] ? true : false
                                }
                                className="align-self-center"
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              GAM Login Banner
                            </label>
                            <Input
                              type="textarea"
                              name="bannerLogin"
                              style={{
                                height: "150px",
                                paddingLeft: "20px",
                                fontFamily:
                                  "'Courier New', Consolas, Menlo, Monaco, 'Lucida Console', monospace",
                                fontSize: "14px",
                                lineHeight: "1.5",
                                letterSpacing: "0.5px",
                              }}
                              onChange={(e) =>
                                Utilities.handleInputChange(
                                  e,
                                  values,
                                  setValues,
                                )
                              }
                              rows="15"
                              value={
                                values["bannerLogin"]
                                  ? values["bannerLogin"]
                                  : ""
                              }
                              readOnly={
                                !values.syncBannerInformation ||
                                values.type == "hospitality"
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col></Col>
              </Row>
            </Col>
          </Row>
          <Button className="btn-round" color="info" type="submit">
            Submit
          </Button>
        </Form>
      </div>
    </>
  );
};

export default GamConfigurationEdit;
